import { atom } from "jotai";

type Theme = {
  company: string,
  logo: string,
  handle: string,
  avatar: string,
  primary: string;
  secondary: string;
  alternate: string;
  overlay: string;
  nav_card_gradient: string;
  date_card_gradient: string;
  heatmap: {
    r: number;
    g: number;
    b: number;
  };
  progress: string;
  infogrid_gradient_one: string;
  infogrid_gradient_two: string;
  lineup_date: string;
  showRecommend: boolean,
  isClient: boolean
  markedCampaignName: string | undefined;
  showTemplate: boolean,
  isImageClient: boolean,
  isVideoClient: boolean,
};

const url = window.location.hostname
// const url = "self_stg"
// const url = "adidas"
// const url = "chapelhill_stg"
// const url = "chapelhill_dev"
// const url = "deko"
// const url = "amymd"
// const url = "yogasix"
// const url = "6pminparis"
// const url = "xengaming"

const selfTheme: Theme = {
  company: "siAi",
  handle: "siailive",
  logo: "https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9gPMuQUtwF0CP76UMT8GShx15JmbzeVWknDEO",
  avatar: "https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9mMiSpn8BESupc3KwDzo4tbeGVHYWUAdQyl5j",
  primary: "#5b21b6",
  secondary: "#9694FF",
  alternate: "#d666ff",
  overlay: "#ddabff",
  nav_card_gradient: "",
  date_card_gradient: "bg-gradient-to-tl from-[#5b21b6] to-[rgba(91,33,182,0.4)]",
  heatmap: {
    r: 154,
    g: 0,
    b: 219
  },
  progress: "bg-gradient-to-r from-[#5b21b6] to-[#FCC737]",
  infogrid_gradient_one: "bg-gradient-to-tl from-[#5b21b6] to-[rgba(91,33,182,0.4)]",
  infogrid_gradient_two: "bg-gradient-to-tl from-[#5b21b6] to-[#9694FF]",
  lineup_date: "bg-gradient-to-tl from-[#5b21b6] to-[rgba(91,33,182,0.4)]",
  showRecommend: true,
  isClient: true,
  markedCampaignName: "Brand Story Campaigns",
  showTemplate: true,
  isImageClient: true,
  isVideoClient: false
}

const sixpmTheme: Theme = {
  company: "6pm in Paris",
  handle: "6pminparis",
  logo: "https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9EuSKfyLrnReDi6XTOIJ9jWxym7tNw203VfdP",
  avatar: "https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9IlZOkDqqx7JnezRM42NOs0kKBpFuST9W1Plh",
  primary: "#5b21b6",
  secondary: "#9694FF",
  alternate: "#d666ff",
  overlay: "#ddabff",
  nav_card_gradient: "",
  date_card_gradient: "bg-gradient-to-tl from-[#5b21b6] to-[rgba(91,33,182,0.4)]",
  heatmap: {
    r: 154,
    g: 0,
    b: 219
  },
  progress: "bg-gradient-to-r from-[#5b21b6] to-[#FCC737]",
  infogrid_gradient_one: "bg-gradient-to-tl from-[#5b21b6] to-[rgba(91,33,182,0.4)]",
  infogrid_gradient_two: "bg-gradient-to-tl from-[#5b21b6] to-[#9694FF]",
  lineup_date: "bg-gradient-to-tl from-[#5b21b6] to-[rgba(91,33,182,0.4)]",
  showRecommend: true,
  isClient: true,
  markedCampaignName: "Marked Campaign",
  showTemplate: true,
  isImageClient: true,
  isVideoClient: false
}


const dekoTheme: Theme = {
  company: "Deko Cocktails",
  handle: "dekococktails",
  logo: "https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9cHYlbbx3mstD4JAzkpPHjyhYqC1geQLbTXnx",
  avatar: "https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9mXIGhz8BESupc3KwDzo4tbeGVHYWUAdQyl5j",
  primary: "#D7A57B",
  secondary: "#C95803",
  alternate: "#FCC737",
  overlay: "#ffdea6",
  nav_card_gradient: "",
  date_card_gradient: "bg-gradient-to-tl from-[#C95803] to-[#D7A57B]",
  heatmap: {
    r: 201,
    g: 88,
    b: 3
  },
  progress: "bg-gradient-to-r from-[#5b21b6] to-[#FCC737]",
  infogrid_gradient_one: "bg-gradient-to-tl from-[#FF9F4D] to-[#D96300]",
  infogrid_gradient_two: "bg-gradient-to-tl from-[#D7A57B] to-[#B65300]",
  lineup_date: "bg-gradient-to-tl from-[#5b21b6] to-[rgba(91,33,182,0.4)",
  showRecommend: true,
  isClient: true,
  markedCampaignName: "Marked Campaign",
  showTemplate: true,
  isImageClient: false,
  isVideoClient: false
}

const yogasixTheme: Theme = {
  company: "yogasix",
  handle: "yogasix_newprovidence",
  logo: "https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9nvLOoujFXeoEuz1R0LN8a2SkPDg9MshcvKfx",
  avatar: "https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9uqjmyoYtL7SJ0rTgHzenhCXvMKkpRbqOoQly",
  primary: "#286152",
  secondary: "#22B18C",
  alternate: "#004E64",
  overlay: "#a6cbff",
  nav_card_gradient: "",
  date_card_gradient: "bg-gradient-to-tl from-[#286152] to-[#22B18C]",
  heatmap: {
    r: 154,
    g: 0,
    b: 219
  },
  progress: "bg-gradient-to-r from-[#286152] to-[#004E64]",
  infogrid_gradient_one: "bg-gradient-to-tl from-[#286152] to-[#22B18C]",
  infogrid_gradient_two: "bg-gradient-to-tl from-[#004E64] to-[#286152]",
  lineup_date: "bg-gradient-to-tl from-[#22B18C] to-[#004E64]",
  showRecommend: false,
  isClient: true,
  markedCampaignName: undefined,
  showTemplate: false,
  isImageClient: false,
  isVideoClient: false
}

const adidasTheme: Theme = {
  company: "Adidas",
  handle: "adidas",
  logo: "https://86v8u6agau.ufs.sh/f/A17KOoeuO4h95vNQADlFDOufSos95J3jPxl0RznXcgQIEt2v",
  avatar: "https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9Bd69hwR2qR3iPoSdmtNlb15sQ0WyYXzrIU8T",
  primary: "#5b21b6",
  secondary: "#9694FF",
  alternate: "#d666ff",
  overlay: "#ddabff",
  nav_card_gradient: "",
  date_card_gradient: "bg-gradient-to-tl from-[#5b21b6] to-[rgba(91,33,182,0.4)]",
  heatmap: {
    r: 154,
    g: 0,
    b: 219
  },
  progress: "bg-gradient-to-r from-[#5b21b6] to-[#FCC737]",
  infogrid_gradient_one: "bg-gradient-to-tl from-[#5b21b6] to-[rgba(91,33,182,0.4)]",
  infogrid_gradient_two: "bg-gradient-to-tl from-[#5b21b6] to-[#9694FF]",
  lineup_date: "bg-gradient-to-tl from-[#5b21b6] to-[rgba(91,33,182,0.4)]",
  showRecommend: true,
  isClient: true,
  markedCampaignName: "Brand Story Campaigns",
  showTemplate: false,
  isImageClient: true,
  isVideoClient: false
}

const chaphillDevTheme: Theme = {
  company: "Griff's Toffee",
  handle: "griffstoffee",
  logo: "https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9kyM5hbaXQk8VNqratMnmCpS4zfRsexALWOPi",
  avatar: "https://86v8u6agau.ufs.sh/f/A17KOoeuO4h97rg9hTdV6bxPtZ4eo5pUzAirDQTjchWB9wf8",
  primary: "#578df2",
  secondary: "#0c50cf",
  alternate: "#0093e3",
  overlay: "#7daaff",
  nav_card_gradient: "",
  date_card_gradient: "bg-gradient-to-tl from-[#578df2] to-[#0093e3]",
  heatmap: {
    r: 154,
    g: 0,
    b: 219
  },
  progress: "bg-gradient-to-r from-[#5b21b6] to-[#FCC737]",
  infogrid_gradient_one: "bg-gradient-to-tl from-[#578df2] to-[#0c50cf]",
  infogrid_gradient_two: "bg-gradient-to-tl from-[#5b21b6] to-[#578df2]",
  lineup_date: "bg-gradient-to-tl from-[#5b21b6] to-[#0093e3]",
  showRecommend: true,
  isClient: true,
  markedCampaignName: "Brand Campaign",
  showTemplate: true,
  isImageClient: false,
  isVideoClient: true
}

const chaphillTheme: Theme = {
  company: "Griff's Toffee",
  handle: "griffstoffee",
  logo: "https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9kyM5hbaXQk8VNqratMnmCpS4zfRsexALWOPi",
  avatar: "https://86v8u6agau.ufs.sh/f/A17KOoeuO4h97rg9hTdV6bxPtZ4eo5pUzAirDQTjchWB9wf8",
  primary: "#578df2",
  secondary: "#0c50cf",
  alternate: "#0093e3",
  overlay: "#7daaff",
  nav_card_gradient: "",
  date_card_gradient: "bg-gradient-to-tl from-[#578df2] to-[#0093e3]",
  heatmap: {
    r: 154,
    g: 0,
    b: 219
  },
  progress: "bg-gradient-to-r from-[#5b21b6] to-[#FCC737]",
  infogrid_gradient_one: "bg-gradient-to-tl from-[#578df2] to-[#0c50cf]",
  infogrid_gradient_two: "bg-gradient-to-tl from-[#5b21b6] to-[#578df2]",
  lineup_date: "bg-gradient-to-tl from-[#5b21b6] to-[#0093e3]",
  showRecommend: true,
  isClient: true,
  markedCampaignName: "Brand Campaign",
  showTemplate: true,
  isImageClient: false,
  isVideoClient: false
}

const amymdTheme: Theme = {
  company: "Ask Me Your MD",
  handle: "askemyourmd",
  logo: "https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9V1e0WWslPbXwu3RaNjiHtfTxk9UroyzZ261Y",
  avatar: "https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9HfwHnINMor0Nh4Jfi5AVDOw6lmEq82F9dasj",
  primary: "#9924ff",
  secondary: "#9694FF",
  alternate: "#d666ff",
  overlay: "#ddabff",
  nav_card_gradient: "",
  date_card_gradient: "bg-gradient-to-tl from-[#5b21b6] to-[rgba(91,33,182,0.4)]",
  heatmap: {
    r: 154,
    g: 0,
    b: 219
  },
  progress: "bg-gradient-to-r from-[#9924ff] to-[#FCC737]",
  infogrid_gradient_one: "bg-gradient-to-tl from-[#9924ff] to-[rgba(91,33,182,0.4)]",
  infogrid_gradient_two: "bg-gradient-to-tl from-[#9924ff] to-[#9694FF]",
  lineup_date: "bg-gradient-to-tl from-[#9924ff] to-[rgba(91,33,182,0.4)]",
  showRecommend: true,
  isClient: true,
  markedCampaignName: undefined,
  showTemplate: true,
  isImageClient: true,
  isVideoClient: false
}

const xenTheme: Theme = {
  company: "Xen Gaming",
  handle: "XenGGs",
  logo: "https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9QjIE2S5xda1XtZpLHfOboP0vMFKu9IY274BV",
  avatar: "https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9EK44PnLrnReDi6XTOIJ9jWxym7tNw203VfdP",
  primary: "#5b21b6",
  secondary: "#9694FF",
  alternate: "#d666ff",
  overlay: "#ddabff",
  nav_card_gradient: "",
  date_card_gradient: "bg-gradient-to-tl from-[#5b21b6] to-[rgba(91,33,182,0.4)]",
  heatmap: {
    r: 154,
    g: 0,
    b: 219
  },
  progress: "bg-gradient-to-r from-[#5b21b6] to-[#FCC737]",
  infogrid_gradient_one: "bg-gradient-to-tl from-[#5b21b6] to-[rgba(91,33,182,0.4)]",
  infogrid_gradient_two: "bg-gradient-to-tl from-[#5b21b6] to-[#9694FF]",
  lineup_date: "bg-gradient-to-tl from-[#5b21b6] to-[rgba(91,33,182,0.4)]",
  showRecommend: true,
  isClient: false,
  markedCampaignName: "Brand Story Campaigns",
  showTemplate: false,
  isImageClient: false,
  isVideoClient: false
}

const currentTheme = (url: string): Theme => {
  let theme: Theme
  switch (true) {
    case url.includes("deko"):
      theme = dekoTheme;
      break;
    case url.includes("adidas"):
      theme = adidasTheme;
      break;
    case url.includes("chapelhill_dev"):
      theme = chaphillDevTheme;
      break;
    case url.includes("chapelhill_stg"):
      theme = chaphillTheme;
      break;
    case url.includes("amymd"):
      theme = amymdTheme;
      break;
    case url.includes("xengaming"):
      theme = xenTheme;
      break;
    case url.includes("yogasix"):
      theme = yogasixTheme;
      break;
    case url.includes("self"):
      theme = selfTheme;
      break;
    case url.includes("6pminparis"):
      theme = sixpmTheme;
      break;
    default:
      theme = adidasTheme;
  }

  return theme
}

const defaultValue: Theme = currentTheme(url)

export const themeAtom = atom<Theme>(defaultValue)
